import script from "./AppAside.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAside.vue?vue&type=script&setup=true&lang=js"

import "./AppAside.vue?vue&type=style&index=0&id=4663f1b6&lang=css&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4663f1b6"]])

export default __exports__